import { initializeABTests } from 'nike-ui/src/components/ab-testing/ABTest';

initializeABTests(window.USER_DATA_SNAPSHOT?.abTests);
